import { render, staticRenderFns } from "./ImagesListSetter.vue?vue&type=template&id=753a03e6&"
import script from "./ImagesListSetter.vue?vue&type=script&lang=js&"
export * from "./ImagesListSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImagesListSetter.vue"
export default component.exports